// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dicom-upload-stats {
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.dicom-upload-result {
  padding: 12px;
  background-color: #f0f9ff;
  border-radius: 4px;
  border: 1px solid #91d5ff;
}

.dicom-upload-file-list {
  max-height: 300px;
  overflow-y: auto;
}

.dicom-upload-file-list .ant-list {
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./components/DicomUploadModal/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".dicom-upload-stats {\r\n  padding: 12px;\r\n  background-color: #f5f5f5;\r\n  border-radius: 4px;\r\n}\r\n\r\n.dicom-upload-result {\r\n  padding: 12px;\r\n  background-color: #f0f9ff;\r\n  border-radius: 4px;\r\n  border: 1px solid #91d5ff;\r\n}\r\n\r\n.dicom-upload-file-list {\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.dicom-upload-file-list .ant-list {\r\n  margin-top: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
